const ErrorPage = () => {
  return (
    <div>
      <h1>Error: Something went wrong!</h1>
    </div>
  );
};

export default ErrorPage;
